import { defineStore } from 'pinia';
import { reactive, ref, toRefs, watch } from 'vue';

// FooterOptions 接口，继承自 PaginationProps，增加了可选的 hide 属性用于控制分页器的显示隐藏
interface FooterOptions extends XomFooterOptions {}

// 默认分页器配置
const DEFAULT_FOOTER_OPTIONS: XomFooterOptions = {
  current: 1, // 当前页码
  pageSize: 10, // 每页条数
  total: 0,
  simple: false, // 是否为简单分页模式
  defaultPageSize: 10,
  pageSizeOptions: ['60', '100', '150'],
};

// 定义 Pinia 的 footer 仓库
export const useFooterStore = defineStore('footer', () => {
  // 控制底部栏显示隐藏的状态
  const isFooterShow = ref(false);
  // 底部栏的 DOM 元素引用
  const footerRef = ref<HTMLElement>();
  // 底部分页器的配置项
  const footerOptions = reactive<FooterOptions>({
    ...DEFAULT_FOOTER_OPTIONS,
  });
  // 是否反转底部栏内容的状态
  // const isReverseFooter = ref(false);
  // // 底部栏左侧自定义内容
  // const footerLeftContent = ref<any>();

  // 切换底部栏显示/隐藏，传参则强制设置
  const toggleFooterVisible = (isShow?: boolean) => {
    isFooterShow.value = isShow === undefined ? !isFooterShow.value : isShow;
    if (!isShow) {
      footerRef.value = null;
    }
  };

  // 设置底部分页器的配置项
  const setFooterOptions = (options: XomFooterOptions) => {
    Object.assign(footerOptions, options);
  };

  // // 设置是否反转底部栏内容，传参则强制设置
  // const setReverseFooter = (isReverse?: boolean) => {
  //   isReverseFooter.value = isReverse === undefined ? !isReverseFooter.value : isReverse;
  // };

  // // 设置底部栏左侧自定义内容
  // const setFooterLeftContent = (content: any) => {
  //   footerLeftContent.value = content;
  // };

  // 重置底部分页器为默认配置
  const setFooterDefault = () => {
    setFooterOptions({
      ...DEFAULT_FOOTER_OPTIONS,
    });
  };

  // 设置数据总量 total
  const setTotal = (total: number) => {
    footerOptions.total = total;
  };

  // // 获取底部栏 DOM 元素引用
  // const getFooterRef = () => footerRef.value;

  // 设置底部栏 DOM 元素引用
  const setFooterRef = (el: HTMLElement | null) => {
    footerRef.value = el;
  };

  // 获取当前分页器配置
  const getFooterOptions = () => {
    return { ...footerOptions };
  };

  // 注册分页变化回调并立即监听
  const onPageChange = (cb: (current: number, pageSize: number) => void) => {
    watch(
      () => footerOptions.current,
      (current) => {
        cb(current, footerOptions.pageSize);
      },
    );
  };
  // 注册分页变化回调并立即监听
  const onPageSizeChange = (cb: (current: number, pageSize: number) => void) => {
    watch(
      () => footerOptions.pageSize,
      (size) => {
        cb(footerOptions.current, size);
      },
    );
  };

  // 注册分页器配置变化回调并立即监听
  const onFooterOptionsChange = (cb: (options: XomFooterOptions) => void) => {
    watch(
      () => footerOptions,
      (newly) => {
        cb({ ...newly });
      },
    );
  };

  // 导出仓库的 state 和方法
  return {
    ...toRefs({
      isFooterShow, // 底部栏显示状态
      footerRef, // 底部栏 DOM 引用
      footerOptions: {
        ...footerOptions,
      }, // 分页器配置
    }),
    getFooterOptions, // 获取分页器配置
    setFooterOptions, // 设置分页器配置
    toggleFooterVisible, // 切换底部栏显示
    setFooterDefault, // 重置分页器为默认
    // setFooterLeftContent, // 设置左侧内容
    // setReverseFooter, // 设置反转状态
    setTotal, // 设置数据总量
    // getFooterRef, // 获取底部栏 DOM
    setFooterRef, // 设置底部栏 DOM
    onPageChange, // 注册分页变化回调
    onPageSizeChange,
    onFooterOptionsChange, // 注册分页器配置变化回调
  };
});
